/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPONCEOFFINVESTMENTSOURCEOFMONEY } from './IAPONCEOFFINVESTMENTSOURCEOFMONEY';
import {
    IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSON,
    IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSONTyped,
    IAPONCEOFFINVESTMENTSOURCEOFMONEYToJSON,
} from './IAPONCEOFFINVESTMENTSOURCEOFMONEY';

/**
 * 
 * @export
 * @interface ChangeOnceOffSourceOfMoneyOrchestration
 */
export interface ChangeOnceOffSourceOfMoneyOrchestration {
    /**
     * 
     * @type {number}
     * @memberof ChangeOnceOffSourceOfMoneyOrchestration
     */
    proposalId: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeOnceOffSourceOfMoneyOrchestration
     */
    productId: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeOnceOffSourceOfMoneyOrchestration
     */
    proceedWithDataLoss: boolean;
    /**
     * 
     * @type {IAPONCEOFFINVESTMENTSOURCEOFMONEY}
     * @memberof ChangeOnceOffSourceOfMoneyOrchestration
     */
    onceOffSourceOfMoney: IAPONCEOFFINVESTMENTSOURCEOFMONEY;
}

/**
 * Check if a given object implements the ChangeOnceOffSourceOfMoneyOrchestration interface.
 */
export function instanceOfChangeOnceOffSourceOfMoneyOrchestration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "proceedWithDataLoss" in value;
    isInstance = isInstance && "onceOffSourceOfMoney" in value;

    return isInstance;
}

export function ChangeOnceOffSourceOfMoneyOrchestrationFromJSON(json: any): ChangeOnceOffSourceOfMoneyOrchestration {
    return ChangeOnceOffSourceOfMoneyOrchestrationFromJSONTyped(json, false);
}

export function ChangeOnceOffSourceOfMoneyOrchestrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeOnceOffSourceOfMoneyOrchestration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'productId': json['ProductId'],
        'proceedWithDataLoss': json['ProceedWithDataLoss'],
        'onceOffSourceOfMoney': IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSON(json['OnceOffSourceOfMoney']),
    };
}

export function ChangeOnceOffSourceOfMoneyOrchestrationToJSON(value?: ChangeOnceOffSourceOfMoneyOrchestration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'ProductId': value.productId,
        'ProceedWithDataLoss': value.proceedWithDataLoss,
        'OnceOffSourceOfMoney': IAPONCEOFFINVESTMENTSOURCEOFMONEYToJSON(value.onceOffSourceOfMoney),
    };
}

